@if (visaResponse.method !== "GET") {
  <form
    ngNoForm
    [action]="visaResponse.acsUrl"
    method="POST"
    #testForm
    target="secure3dFrame"
  >
    @if (visaResponse.method !== "GET") {
      <input type="hidden" name="MD" value="{{ visaResponse.md }}" />
    }
    @if (visaResponse.method !== "GET") {
      <input
        type="hidden"
        name="JWT"
        value="{{ visaResponse.jwt }}"
        placeholder="JWT"
      />
    }
    @if (visaResponse.method !== "GET") {
      <input type="hidden" name="TermUrl" value="{{ visaResponse.termUrl }}" />
    }
  </form>
  <iframe
    title="Secure-3D Authorization"
    id="secure3dFrame"
    name="secure3dFrame"
    class="secure3d-frame"
    frameBorder="0"
  >
    No iframe support
  </iframe>
}

@if (visaResponse.method === "GET") {
  <iframe
    #getIframe
    title="Secure-3D Authorization"
    id="getIframe"
    name="getIframe"
    class="secure3d-frame"
    frameBorder="0"
    [src]="safeUrl"
    (load)="(visaResponse.method === 'GET')"
  >
    No iframe support
  </iframe>
}
